export default {
  settings: {
    behaviourTypeId: null,
    intervalDurationValue: null,
    intervalDurationUnitId: null,
    aimTypeId: null,
  },
  auditor: {},
  assignee: {},
  uuid: null,
  currentInterval: {
    index: null,
    duration: null,
    current: 0,
    behaviourHappenedAt: null,
  },
  isIntervalEnable: false,
  intervals: [],
  startedAt: null,
  finishedAt: null,
  isSessionStarted: false,
  shouldStartIntervalAutomatically: false,
};


// WEBPACK FOOTER //
// ./src/modules/dro/vuex/state.js